<!-- Input Multi Select Template -->
<ng-template #input_multi_select_template>
  <p-multiSelect #multiSelect
    inputId="{{ name }}"
    appendTo="body"
    ariaLabelledBy="{{ name }}_label"
    styleClass="{{ inputClass }}"
    [maxSelectedLabels]="maxSelectedLabels"
    [selectedItemsLabel]="'{0} ' + ('global.selected_items_label' | translate)"
    [disableControl]="disabled"
    [options]="options"
    optionLabel="{{ optionLabel }}"
    optionValue="{{ optionValue }}"
    optionDisabled="{{ optionDisabled }}"
    showToggleAll="{{ showToggleAll }}"
    [group]="group"
    [filter]="(filter === undefined ? options.length >= FlatModels.DropdownDesignModels.DropDownMinFilterLimit : filter)"
    [placeholder]="placeholder | translate"
    [ngModel]="model"
    [ngModelOptions]="{standalone: true}"
    (onChange)="valueChange.emit($event)">
    @if (group; as group) {
      <ng-template
        let-group
        pTemplate="group">
        <div class="flex align-items-center">
          <div>{{ group[optionLabel] | translate }}</div>
        </div>
      </ng-template>
    }
    <ng-template let-entry pTemplate="item">
      <div class="flex align-items-center gap-2">
        <div>{{ entry[optionLabel] | translate }}</div>
      </div>
    </ng-template>
  </p-multiSelect>
</ng-template>
<!-- Text Input -->
<div class="w-full"
     [class.field]="formField">
  @if (label) {
    <label
      id="{{ name }}_label"
      class="flex flex-grow-1 flex-row column-gap-2"
      [class.mb-2]="!formField"
      for="{{ name }}">
      @if (labelIcon) {
        <i class="{{ labelIcon }}"></i>
      }
      <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
        {{ label | translate }}
      </span>
    </label>
  }
  @if (!inputGroup) {
    <ng-container *ngTemplateOutlet="input_multi_select_template"></ng-container>
  } @else {
    <div medsurf-design-content-input-group>
      <ng-container *ngTemplateOutlet="input_multi_select_template"></ng-container>
      <ng-content></ng-content>
    </div>
  }
</div>